import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AuthenticationService} from '../../../shared/features/auth/services/authentication.service';
import {UserService} from '../../../shared/features/auth/services/user.service';
import {Router} from '@angular/router';
import {Globals} from '../../../shared/models/Globals';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FormUtils} from '../../../shared/components/inputs/utils/FormUtils';

@Component({
  standalone: false,
  selector: 'app-lock',
  templateUrl: './lock.component.html',
  styleUrls: ['../login/login.component.scss', './lock.component.scss']
})

export class LockComponent implements OnInit, OnDestroy {

  public passwordFormGroup: FormGroup;
  // Own card: the first .card in the document can still belong to the page being left.
  @ViewChild('lockCard', {static: true}) private lockCard: ElementRef<HTMLElement>;
  private revealTimer: ReturnType<typeof setTimeout>;
  public passwordVisible = false;
  public readonly year = new Date().getFullYear();

  constructor(private authenticationService: AuthenticationService,
              private userService: UserService, private router: Router,
              public globals: Globals, private passwordFormBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.initUI();
    this.initFormBuilder();
  }

  private initUI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('lock-page');
    body.classList.add('off-canvas-sidebar');
    this.revealTimer = setTimeout(() => {
      // after 700 ms we add the class animated to the lock card
      this.lockCard?.nativeElement.classList.remove('card-hidden');
    }, 700);
  }

  private initFormBuilder() {
    this.passwordFormGroup = this.passwordFormBuilder.group({
      currentPassword: [null, Validators.compose([Validators.required, Validators.minLength(8)])],
    });
  }

  ngOnDestroy() {
    clearTimeout(this.revealTimer);
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('lock-page');
    body.classList.remove('off-canvas-sidebar');
  }

  login() {
    if (this.passwordFormGroup.valid) {
      this.userService.loginFromLock(this.globals.mail, this.passwordFormGroup.get('currentPassword').value);
    } else {
      FormUtils.markIncorrectFields(this.passwordFormGroup);
    }
  }

  /** «¿No eres tú? Entrar con otra cuenta»: ends this session and opens the login. */
  useAnotherAccount() {
    this.userService.logout();
  }
}
